import React, { Component } from 'react'
import ClassConductsPV from './ClassConductsPV'
import AuthA from '../../store/actions/AuthA'

import axios from 'axios'
import sortBy from 'lodash/sortBy'
import find from 'lodash/find'
import filter from 'lodash/filter'
import constantCase from 'constant-case'
import paramCase from 'param-case'
import {connect} from 'react-redux'

const _ = { sortBy, find, filter }

const changeCase = {
  constantCase: constantCase,
  paramCase: paramCase,
}

class ClassConductsPC extends Component {
  constructor(props) {
    super(props);
    this.state = {
      classConducts: [],
      section: [],
      sectionId: '',
      column: null,
      direction: null,
      sectionStudents: [],
      error: false,
      success: false,
      fileName: '',
      classConductSheet: null,
      areClassConductsSaved: false,
      quarter: 1,
      modalOpen: false,
      sectionSubjects: [],
      subjectConducts: [],
      sectionStudentId: '',
      dirtyInput: false,
      open: false,
      created: [],
      checked: [],
      reviewed: [],
      sections: []
    };
    this.getClassConducts = this.getClassConducts.bind(this);
    this.getSubjectConducts = this.getSubjectConducts.bind(this);
    this.getSectionStudents = this.getSectionStudents.bind(this);
    this.handleSort = this.handleSort.bind(this);
    this.handleUpdateSectionDetails = this.handleUpdateSectionDetails.bind(this);
  }

  getClassConducts(sectionId, section) {
    const { sectionStudents, quarter } = this.state;
    axios.get(process.env.REACT_APP_URL+'/classConducts?filter[where][active]=true&filter[where][sectionId]='+sectionId)
    .then(response => {
      this.setState({ classConducts: response.data}, () => {
        if (response.data.length !== 0) {
          this.getSubjectConducts(this.state.sectionId, section);
          sectionStudents.map((sectionStudent, key )=> {
            const studentName = sectionStudent.student.lastName +', '+sectionStudent.student.firstName;
            const studentVariable = changeCase.constantCase(studentName);
            const classConduct = _.find(response.data, {
              sectionStudentId: sectionStudent.sectionStudentId
            });

            if (classConduct != null) {
              // will do a special setting for total subjects
              if(quarter === '1') {
                this.setState({
                  [`${studentVariable}-1`]: classConduct.firstQuarter1,
                  [`${studentVariable}-2`]: classConduct.firstQuarter2,
                  [`${studentVariable}-3`]: classConduct.firstQuarter3,
                  [`${studentVariable}`]: classConduct.firstQuarter,
                  [`${studentVariable}-S`]: classConduct.firstQuarterSubjects,
                  [`${studentVariable}-FG`]: classConduct.firstQuarterFinal,
                  areClassConductsSaved: true
                })
              } else if (quarter === '2') {
                this.setState({
                  [`${studentVariable}-1`]: classConduct.secondQuarter1,
                  [`${studentVariable}-2`]: classConduct.secondQuarter2,
                  [`${studentVariable}-3`]: classConduct.secondQuarter3,
                  [`${studentVariable}`]: classConduct.secondQuarter,
                  [`${studentVariable}-S`]: classConduct.secondQuarterSubjects,
                  [`${studentVariable}-FG`]: classConduct.secondQuarterFinal,
                  areClassConductsSaved: true
                })
              } else if (quarter === '3') {
                this.setState({
                  [`${studentVariable}-1`]: classConduct.thirdQuarter1,
                  [`${studentVariable}-2`]: classConduct.thirdQuarter2,
                  [`${studentVariable}-3`]: classConduct.thirdQuarter3,
                  [`${studentVariable}`]: classConduct.thirdQuarter,
                  [`${studentVariable}-S`]: classConduct.thirdQuarterSubjects,
                  [`${studentVariable}-FG`]: classConduct.thirdQuarterFinal,
                  areClassConductsSaved: true
                })
              } else if (quarter === '4') {
                this.setState({
                  [`${studentVariable}-1`]: classConduct.fourthQuarter1,
                  [`${studentVariable}-2`]: classConduct.fourthQuarter2,
                  [`${studentVariable}-3`]: classConduct.fourthQuarter3,
                  [`${studentVariable}`]: classConduct.fourthQuarter,
                  [`${studentVariable}-S`]: classConduct.fourthQuarterSubjects,
                  [`${studentVariable}-FG`]: classConduct.fourthQuarterFinal,
                  areClassConductsSaved: true
                })
              }

              return true;
            } else {
              this.setState({
                [`${studentVariable}-1`]: 0,
                [`${studentVariable}-2`]: 0,
                [`${studentVariable}-3`]: 0,
                [`${studentVariable}`]: 0,
                [`${studentVariable}-S`]: 0,
                [`${studentVariable}-FG`]: 0,
                areClassConductsSaved: true
              })

              return true;
            }

          })
        } else {
          sectionStudents.map((sectionStudent, key )=> {
            const studentName = sectionStudent.student.lastName +', '+sectionStudent.student.firstName;
            const studentVariable = changeCase.constantCase(studentName);
            this.getSubjectConducts(this.state.sectionId, section)
            this.setState({
              [`${studentVariable}-1`]: 0,
              [`${studentVariable}-2`]: 0,
              [`${studentVariable}-3`]: 0,
              [`${studentVariable}`]: 0,
              [`${studentVariable}-S`]: 0,
              [`${studentVariable}-FG`]: 0,
              areClassConductsSaved: true
            })

            return true;
          })
        }
      });
    });
  }

  getSubjectConducts(sectionId, section) {
    const {sectionStudents, quarter} = this.state
    axios.get(process.env.REACT_APP_URL+'/conducts/section?sectionId='+sectionId)
    .then(response => {
        let sectionSubjectsFiltered = [];
        if (section.length !== 0) {
          if (section[0].levelType === 'SHSSTEM' || section[0].levelType === 'SHSHUMSS' || section[0].levelType === 'SHSABM') {
            if (quarter === '1' || quarter === '2') {
              sectionSubjectsFiltered = _.filter(response.data.sectionSubjects, (sectionSubject) => {
                if (sectionSubject.sem.includes("1")) {
                  return sectionSubject;
                }
              });
            } else if (quarter === '3' || quarter === '4') {
              sectionSubjectsFiltered = _.filter(response.data.sectionSubjects, (sectionSubject) => {
                if (sectionSubject.sem.includes("2")) {
                  return sectionSubject;
                }
              });
            } else {
              sectionSubjectsFiltered = response.data.sectionSubjects;
            }
          } else {
            sectionSubjectsFiltered = response.data.sectionSubjects;
          }
        }

        sectionStudents.map((sectionStudent, key )=> {
          const studentName = sectionStudent.student.lastName +', '+sectionStudent.student.firstName;
          const studentVariable = changeCase.constantCase(studentName);

          let totalConduct = 0;
          response.data.conducts.map((conduct, key) => {
            const conductHasSubject = _.find(sectionSubjectsFiltered, (sectionSubject) => {
              if (sectionSubject.sectionSubjectId === conduct.sectionSubjectId) {
                return true
              } else {
                return false;
              }
            });
            if (sectionStudent.sectionStudentId === conduct.sectionStudentId && conductHasSubject) {
              if(quarter === '1') {
                totalConduct = totalConduct + parseInt(conduct.firstQuarter);
              } else if (quarter === '2') {
                totalConduct = totalConduct + parseInt(conduct.secondQuarter);
              } else if (quarter === '3') {
                totalConduct = totalConduct + parseInt(conduct.thirdQuarter);
              } else if (quarter === '4') {
                totalConduct = totalConduct + parseInt(conduct.fourthQuarter);
              }
            } else {
              totalConduct = totalConduct + 0;
            }
            return true;
          })
          let average = totalConduct / sectionSubjectsFiltered.length;
          average = parseFloat(average.toFixed(2))
          if(this.state[`${studentVariable}-S`] !== average) {
            let final = average + 60 + parseFloat(this.state[`${studentVariable}`]);
            final = parseFloat(final.toFixed(2))
            this.setState({
              [`${studentVariable}-S`]: average,
              [`${studentVariable}-FG`]: final,
              dirtyInput: true
            })
          }

          return true;
        })

      this.setState({ sectionSubjects: sectionSubjectsFiltered, subjectConducts: response.data.conducts});
    });
  }


  getSection = (sectionId) => {
    axios.get(process.env.REACT_APP_URL+'/sections?filter[where][active]=true&filter[include]=details&filter[where][sectionId]='+sectionId)
    .then(async(response) => {

      await this.getSectionDetailsForChecking();
      await this.getSectionDetailsForReview();
      await this.getSectionDetailsForApproval();
      await this.getSections();
      await this.getSectionStudents(sectionId, response.data);
      this.setState({ section: response.data});
    })
  }

  getSectionDetailsForChecking = async() => {
    await axios.get(process.env.REACT_APP_URL+`/sectionDetails?filter[where][active]=true&filter[include]=section&filter[where][status]=Created&filter[where][type]=conduct&filter[where][quarter]=${this.state.quarter}`)
    .then(response => {
      this.setState({created: response.data})
    });
  }

  getSectionDetailsForReview = async() => {
    await axios.get(process.env.REACT_APP_URL+`/sectionDetails?filter[where][active]=true&filter[include]=section&filter[where][status]=Checked&filter[where][type]=conduct&filter[where][quarter]=${this.state.quarter}`)
    .then(response => {
      this.setState({checked: response.data})
    });
  }

  getSectionDetailsForApproval = async() => {
    await axios.get(process.env.REACT_APP_URL+`/sectionDetails?filter[where][active]=true&filter[include]=section&filter[where][status]=Reviewed&filter[where][type]=conduct&filter[where][quarter]=${this.state.quarter}`)
    .then(response => {
      this.setState({reviewed: response.data})
    });
  }

  getSections = async() => {
    await axios.get(process.env.REACT_APP_URL+'/sections?filter[where][active]=true')
    .then(response => {
      this.setState({ sections: response.data });
    });
  }

  getSectionStudents(sectionId, section) {
    axios.get(process.env.REACT_APP_URL+'/sectionStudents?filter[where][active]=true&filter[include]=student&filter[where][sectionId]='+sectionId)
    .then(response => {
      const sorted = _.sortBy(response.data, function(o){return [o.student.lastName, o.student.firstName]})
      this.setState({ sectionStudents: sorted }, () => {
        this.getClassConducts(this.state.sectionId, section);
      });
    });
  }

  handleApprovalOpen = () => {
    this.setState({
      open: true
    })
  }

  handleApprovalClose = () => this.setState({
    open: false
  })

  handleOpen = (sectionStudentId) => {
    this.setState({
      modalOpen: true,
      sectionStudentId: sectionStudentId
    })
  }

  handleClose = () => this.setState({
    modalOpen: false,
    sectionStudentId: ''
  })

  handleSort(clickedColumn) {
    const { column, sectionStudents, direction } = this.state
    if (column !== clickedColumn) {
      if(clickedColumn === 'name') {
        this.setState({
          column: clickedColumn,
          sectionStudents: _.sortBy(sectionStudents, function(o){return o.student.lastName}),
          direction: 'ascending',
        })
        return
      } else {
        this.setState({
          column: clickedColumn,
          sectionStudents: _.sortBy(sectionStudents, [clickedColumn]),
          direction: 'ascending',
        })
        return
      }
    }
    this.setState({
      sectionStudents: sectionStudents.reverse(),
      direction: direction === 'ascending' ? 'descending' : 'ascending',
    })
  }

  handleChange = (e, { name, value }) => {
    if (name.includes('-')) {
      const stateName = name.split('-');
      let total=0;
      const changedNumber = isNaN(parseInt(value)) ? 0 : parseInt(value);

      for(let i = 1; i < 4; i++) {
        if(parseInt(stateName[1]) !== i) {
          total = parseInt(total) + parseInt(this.state[`${stateName[0]}-${i}`])
        }
      }
      total = parseInt(total) + changedNumber;
      const final = total + this.state[`${stateName[0]}-S`] + 60;
      this.setState({[stateName[0]]: total, [`${stateName[0]}-FG`]: Math.round(final), [name]: value, dirtyInput: true})
    } else {
      this.setState({[name]: value, dirtyInput: true})
    }
  }

  handleUpdateSectionDetails(data, id) {
    const url = process.env.REACT_APP_URL+'/sectionDetails/'+id;
    axios
      .request({
        method: 'put',
        url: url,
        data: data
      })
      .then(response => {
        this.setState({open: false}, this.getSection(this.state.sectionId))

      })
      .catch(err => console.log(err));
  }

  handleSubmit = () => {
    const {sectionStudents, quarter} = this.state;

    // Validations
    let hasInvalidValue = sectionStudents.some((sectionStudent) => {
      const studentName = sectionStudent.student.lastName +', '+sectionStudent.student.firstName;
      const studentVariable = changeCase.constantCase(studentName);

      if(this.state[studentVariable] === undefined) {
        return true;
      }

      return parseInt(this.state[studentVariable],10) < 1 || parseInt(this.state[studentVariable],10) > 15 || this.state[studentVariable] === ''
    });

    if (hasInvalidValue) {
      this.setState({error: hasInvalidValue, success: false})
    } else {
      sectionStudents.map((sectionStudent, key )=> {
        const studentName = sectionStudent.student.lastName +', '+sectionStudent.student.firstName;
        const studentVariable = changeCase.constantCase(studentName);

        const sectionStudentId = sectionStudent.sectionStudentId;
        const sectionId = this.state.sectionId;

        let quarterLabel;
        if (quarter === '1') {
          quarterLabel = 'firstQuarter';
        } else if (quarter === '2') {
          quarterLabel = 'secondQuarter';
        } else if (quarter === '3') {
          quarterLabel = 'thirdQuarter';
        } else if (quarter === '4') {
          quarterLabel = 'fourthQuarter';
        }

        const data = {
          sectionStudentId: sectionStudentId,
          sectionId: sectionId,
          [quarterLabel]:  this.state[studentVariable],
          [`${quarterLabel}1`]:  this.state[`${studentVariable}-1`],
          [`${quarterLabel}2`]:  this.state[`${studentVariable}-2`],
          [`${quarterLabel}3`]:  this.state[`${studentVariable}-3`],
          [`${quarterLabel}Subjects`]:  this.state[`${studentVariable}-S`],
          [`${quarterLabel}Final`]:  this.state[`${studentVariable}-FG`]
        }

        const url = process.env.REACT_APP_URL+'/classConducts/upsertWithWhere?where={"sectionId":"'+sectionId+'","sectionStudentId":"'+sectionStudentId+'"}';
        axios
          .request({
            method: 'post',
            url: url,
            data: data
          })
          .then(response => {
            if (key === sectionStudents.length-1) {
              this.setState({success: true}, () => this.getClassConducts(sectionId, this.state.section));
            }
          })
          .catch(err => console.log(err));

        return true;
      })
      this.setState({success: true, error: false, dirtyInput: false, open: true})
    }
  }

  componentDidMount() {
    this.props.authFn.getToken()
    this.props.onContentMount({title:'Class Conduct'});

    const sectionId = this.props.match.params.sectionId;
    const params = new URLSearchParams(this.props.location.search);
    const quarter = params.get('quarter');
    this.setState({quarter: quarter, sectionId: sectionId}, () => {
      this.getSection(sectionId);

    })

  }

  componentWillReceiveProps(newProps) {

    const sectionId = newProps.match.params.sectionId;
    const params = new URLSearchParams(newProps.location.search);
    const quarter = params.get('quarter');
    this.setState({quarter: quarter, sectionId: sectionId}, () => {
      this.getSection(sectionId);
      // this.getSectionStudents(sectionId);
    })

  }

  render() {
    return (
      <ClassConductsPV
        auth={this.props.auth}
        username={this.props.username}
        userType={this.props.userType}
        userId={this.props.userId}
        column={this.state.column}
        direction={this.state.direction}
        section={this.state.section}
        quarter={this.state.quarter}
        sectionStudents={this.state.sectionStudents}
        error={this.state.error}
        success={this.state.success}
        areClassConductsSaved={this.state.areClassConductsSaved}
        modalOpen={this.state.modalOpen}
        open={this.state.open}
        subjectConducts={this.state.subjectConducts}
        sectionSubjects={this.state.sectionSubjects}
        sectionStudentId={this.state.sectionStudentId}
        dirtyInput={this.state.dirtyInput}
        created={this.state.created}
        checked={this.state.checked}
        reviewed={this.state.reviewed}
        sections={this.state.sections}
        {...this.state}
        handleApprovalOpen={this.handleApprovalOpen}
        handleApprovalClose={this.handleApprovalClose}
        handleOpen={this.handleOpen}
        handleClose={this.handleClose}
        handleSort={this.handleSort}
        handleChange={this.handleChange}
        handleSubmit={this.handleSubmit}
        handleUpdateSectionDetails={this.handleUpdateSectionDetails}
      />
    );
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    authFn: AuthA(dispatch)
  }
}

const mapStateToProps = (state) => {
  return {
    auth: state.AuthR.auth,
    username: state.AuthR.username,
    userType: state.AuthR.userType,
    userId: state.AuthR.userId
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(ClassConductsPC);
